<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
    <div id="vue" class="test-spa"></div>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews () {
      return this.$store.state.tagsView.cachedViews
    },
    key () {
      return this.$route.path
    },
  },
  data () {
    return {
      visibleSubApp: false,
    }
  },
  methods: {
    handleAfterLeave (el) {
      this.visibleSubApp = true
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.app-main {
  /* 64= navbar  64  */
  height: calc(100vh - #{$headerHeight});
  width: 100%;
  position: relative;
  overflow: auto;
}

.fixed-header + .app-main {
  padding-top: 64px;
}

.hasTagsView {
  .app-main {
    /* 98 = navbar + tags-view = 64 + 34 */
    height: calc(100vh - 34px - #{$headerHeight});
  }

  .fixed-header + .app-main {
    padding-top: 98px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
.vue-sso {
  height: 100%;
  aside {
    padding: 10px;
    margin-bottom: 0;
    padding-right: 0;
    background: none;
  }
  main.el-main.ex-main {
    padding: 10px;
    padding-left: 0;
  }
}
</style>
